import angular from 'angular';
import { ContainsFocusModule } from '../contains-focus';
import { MenuFocusModule } from '../menu-focus';
import { PopupToggleButtonComponent } from './popup-toggle-button.component';
import { PopupMenuComponent } from './popup-menu.component';
import { PopupToggleService } from './popup-toggle.service';

export const PopupModule = angular
  .module('app.components.popup', [
    ContainsFocusModule.name,
    MenuFocusModule.name,
  ])
  .component('updPopupToggleButton', PopupToggleButtonComponent)
  .component('updPopupMenu', PopupMenuComponent)
  .service('updPopupToggleService', PopupToggleService);
